import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Navigation from '../Navigation';
import LandingPage from '../Landing';
import WebinarPage from '../Webinar';
import WebinarThankYouPage from '../WebinarThankYou';
import AboutPage from '../About';
import DivisionsPage from '../Divisions';
import WhyPartnerPage from '../WhyPartner';
import PartnershipModelPage from '../PartnershipModel';
import LeadershipPage from '../Leadership';
import ContactPage from '../Contact';
import InsightsPage from '../Insights';
import InsightPost from '../Insights/InsightPost';
import FranchiseProductPage from '../LandingCopy/FranchiseProductPage';
import FranchiseDashboardDemoPage from '../LandingCopy/FranchiseDashboardDemoPage';
import SignUpPage from '../SignUp';
import SignInPage from '../SignIn';
import PasswordForgetPage from '../PasswordForget';
import PasswordChangePage from '../PasswordChange/PasswordChangePage';
import EmailVerificationPage from '../EmailVerification';
import DashboardPage from '../Dashboard';
import SettingsPage from '../Settings';
import HomePage from '../Home';
import AccountPage from '../Account';
import AdminPage from '../Admin';
import FranchiseOnboardingPage from '../FranchiseOnboarding';
import FranchiseDashboardPage from '../FranchiseDashboard';
import FranchiseBrandKitPage from '../FranchiseBrandKit';
import StudioEditorOnlyPage from '../../modules/studio/pages/StudioEditorOnlyPage';
import { AdminSignIn, AdminDashboard, BuilderDashboard, CustomerDetail, CustomerDetailsPage } from '../AdminPanel';
import FranchiseDetail from '../AdminPanel/FranchiseDetail';
import FranchiseAgreement from '../FranchiseAgreement';
import CRMApp from '../../modules/crm/pages/CRMApp';
import PortalLogin from '../../modules/crm-portal/PortalLogin';
import PortalJoin from '../../modules/crm-portal/PortalJoin';
import PortalResetPin from '../../modules/crm-portal/PortalResetPin';
import PortalGuard from '../../modules/crm-portal/PortalGuard';
import PortalCRMApp from '../../modules/crm-portal/PortalCRMApp';
import PaymentSuccess from '../PaymentSuccess';
import PaymentFailure from '../PaymentFailure';
import TermsConditions from '../TermsConditions';
import PrivacyPolicy from '../PrivacyPolicy';
import CancellationRefund from '../CancellationRefund';
import RouteMetadataManager from '../SEO/RouteMetadataManager';
import AnalyticsTracker from '../Analytics/AnalyticsTracker';

import * as ROUTES from '../../constants/routes';
import { withAuthentication } from '../Session';

const App = () => (
  <Router>
    <RouteMetadataManager />
    <AnalyticsTracker />
    <Switch>
      <Route exact path={ROUTES.LANDING} component={LandingPage} />
      <Route exact path="/webinar" component={WebinarPage} />
      <Route exact path="/webinar-thank-you" component={WebinarThankYouPage} />
      <Route exact path="/about" component={AboutPage} />
      <Route exact path="/divisions" component={DivisionsPage} />
      <Route exact path="/why-partner" component={WhyPartnerPage} />
      <Route exact path="/partnership-model" component={PartnershipModelPage} />
      <Route exact path="/leadership" component={LeadershipPage} />
      <Route exact path="/contact" component={ContactPage} />
      <Route exact path="/insights" component={InsightsPage} />
      <Route exact path="/insights/:slug" component={InsightPost} />
      <Route exact path="/product/franchise" component={FranchiseProductPage} />
      <Route exact path="/product/franchise-dashboard-demo" component={FranchiseDashboardDemoPage} />
      <Route exact path="/privacy-policy" component={PrivacyPolicy} />
      <Route exact path={ROUTES.FRANCHISE_REGISTRATION_DASHBOARD} component={SignUpPage} />
      <Route path={ROUTES.SIGN_UP} component={SignUpPage} />
      <Route path={ROUTES.SIGN_IN} component={SignInPage} />
      <Route
        path={ROUTES.PASSWORD_FORGET}
        component={PasswordForgetPage}
      />
      <Route
        path={ROUTES.PASSWORD_CHANGE}
        component={PasswordChangePage}
      />
      <Route path={ROUTES.SETTINGS} component={SettingsPage} />
      <Route path={ROUTES.EMAIL_VERIFICATION} component={EmailVerificationPage} />

      {/* Admin Panel Routes */}
      <Route exact path={ROUTES.ADMIN_SIGNIN} component={AdminSignIn} />
      <Route exact path={ROUTES.ADMIN_PANEL} component={AdminDashboard} />
      <Route exact path={ROUTES.ADMIN_BUILDER} component={BuilderDashboard} />
      <Route path={ROUTES.ADMIN_FRANCHISE_DETAIL} component={FranchiseDetail} />
      <Route path={ROUTES.ADMIN_CUSTOMER_DETAIL} component={CustomerDetailsPage} />

      {/* Franchise Agreement Route */}
      <Route path={ROUTES.FRANCHISE_AGREEMENT} component={FranchiseAgreement} />

      {/* Payment Status Routes */}
      <Route path={ROUTES.PAYMENT_SUCCESS} component={PaymentSuccess} />
      <Route path={ROUTES.PAYMENT_FAILURE} component={PaymentFailure} />

      {/* Legal Pages */}
      <Route path={ROUTES.TERMS} component={TermsConditions} />
      <Route path={ROUTES.PRIVACY} component={PrivacyPolicy} />
      <Route path={ROUTES.CANCELLATION_REFUND} component={CancellationRefund} />

      <Route path="/studio-editor/:projectId" component={StudioEditorOnlyPage} />

      {/* CRM Module - separate URL to avoid conflict with franchise-dashboard */}
      {/* CRM Module */}
      <Route path="/CRM/franchise-crm" component={CRMApp} />
      <Route exact path="/crm-portal/login" component={PortalLogin} />
      <Route exact path="/crm-portal/join" component={PortalJoin} />
      <Route exact path="/crm-portal/reset-pin" component={PortalResetPin} />
      <Route
        path="/crm-portal/app"
        render={() => (
          <PortalGuard>
            <PortalCRMApp />
          </PortalGuard>
        )}
      />

      <Route path={ROUTES.DASHBOARD} component={DashboardPage} />
      <Route path={ROUTES.FRANCHISE_BRAND_KIT_VIEW} component={FranchiseBrandKitPage} />
      <Route path={ROUTES.FRANCHISE_DASHBOARD} component={FranchiseDashboardPage} />
      <Route path={ROUTES.ACCOUNT} component={AccountPage} />
      <Route path={ROUTES.FRANCHISE_ONBOARDING} component={FranchiseOnboardingPage} />
      <Route path={ROUTES.HOME} render={() => (
        <div>
          <Navigation />
          <hr />
          <HomePage />
        </div>
      )} />
      <Route path={ROUTES.ADMIN} render={() => (
        <div>
          <Navigation />
          <hr />
          <AdminPage />
        </div>
      )} />
    </Switch>
  </Router>
);

export default withAuthentication(App);
